/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_ProcessingInputs */

const id_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memproses`)
};

const ms_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang diproses`)
};

const da_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandler`)
};

const de_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verarbeitet`)
};

const en_us2_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const es_es2_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando`)
};

const es_mx2_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando`)
};

const fil_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinoproseso`)
};

const fr_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement`)
};

const it_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione`)
};

const hu_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feldolgozás`)
};

const nl_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt verwerkt`)
};

const no_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandles`)
};

const pl_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie`)
};

const pt_br2_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando`)
};

const pt_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A processar`)
};

const ro_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se procesează`)
};

const fi_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsitellään`)
};

const sv_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbetar`)
};

const vi_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang xử lý`)
};

const tr_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşleniyor`)
};

const cs_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpracování`)
};

const bg_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработва се`)
};

const ru_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрабатывается`)
};

const uk_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обробляється`)
};

const ar_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيد المعالجة`)
};

const hi_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोसेस हो रहा है`)
};

const th_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังประมวลผล`)
};

const ja_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理中`)
};

const zh_cn2_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中`)
};

const zh_hant1_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`處理中`)
};

const ko_builds_health_processing = /** @type {(inputs: Builds_Health_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`처리 중`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Builds_Health_ProcessingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_processing = /** @type {((inputs?: Builds_Health_ProcessingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_ProcessingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_processing(inputs)
	if (locale === "ms") return ms_builds_health_processing(inputs)
	if (locale === "da") return da_builds_health_processing(inputs)
	if (locale === "de") return de_builds_health_processing(inputs)
	if (locale === "en-US") return en_us2_builds_health_processing(inputs)
	if (locale === "es-ES") return es_es2_builds_health_processing(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_processing(inputs)
	if (locale === "fil") return fil_builds_health_processing(inputs)
	if (locale === "fr") return fr_builds_health_processing(inputs)
	if (locale === "it") return it_builds_health_processing(inputs)
	if (locale === "hu") return hu_builds_health_processing(inputs)
	if (locale === "nl") return nl_builds_health_processing(inputs)
	if (locale === "no") return no_builds_health_processing(inputs)
	if (locale === "pl") return pl_builds_health_processing(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_processing(inputs)
	if (locale === "pt") return pt_builds_health_processing(inputs)
	if (locale === "ro") return ro_builds_health_processing(inputs)
	if (locale === "fi") return fi_builds_health_processing(inputs)
	if (locale === "sv") return sv_builds_health_processing(inputs)
	if (locale === "vi") return vi_builds_health_processing(inputs)
	if (locale === "tr") return tr_builds_health_processing(inputs)
	if (locale === "cs") return cs_builds_health_processing(inputs)
	if (locale === "bg") return bg_builds_health_processing(inputs)
	if (locale === "ru") return ru_builds_health_processing(inputs)
	if (locale === "uk") return uk_builds_health_processing(inputs)
	if (locale === "ar") return ar_builds_health_processing(inputs)
	if (locale === "hi") return hi_builds_health_processing(inputs)
	if (locale === "th") return th_builds_health_processing(inputs)
	if (locale === "ja") return ja_builds_health_processing(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_processing(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_processing(inputs)
	return ko_builds_health_processing(inputs)
});
export { builds_health_processing as "builds.health.processing" }